import { Component, ViewEncapsulation } from '@angular/core';
import { AiAgentComponent } from '../ai-agent/ai-agent.component';

// Redesigned agent screen (specs/ai-agent-home-redesign), shown when environment.enableNewAgentHome
// is true. All state and logic live in AiAgentComponent, so both designs behave the same and the
// previous design (app-ai-agent) can be switched back on with the flag alone.
@Component({
  selector: 'app-ai-agent-v2',
  templateUrl: './ai-agent-v2.component.html',
  styleUrls: ['./ai-agent-v2.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AiAgentV2Component extends AiAgentComponent {
  protected override remindMeEnabled = true;
}
